import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import SocieteAndUserService from "../../../services/societeAndUser";

import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import SocieteInformation from "../../../ui/SocieteInformation";
import ClientSocieteTable from "./ClientSocieteTable";
import ClientGroupeTable from "./ClientGroupeTable";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../components/layouts/WithLoader";

const ClientSociete = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  const [allSuppliers, setAllSuppliers] = useState([]);
  const [allGroupes, setAllGroupes] = useState([]);

  const [allSuppliersDeleted, setAllSuppliersDeleted] = useState([]);
  const [allClient, setAllClient] = useState([]);
  const [allClientDeleted, setAllClientDeleted] = useState([]);

  const [informationModel, setInformationModel] = useState();
  const [onShowInformationModel, setOnShowInformationModel] = useState(false);

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const myRefs = useRef([]);
  const myRefsDeleted = useRef([]);
  const myRefsTwo = useRef([]);
  const myRefsTwoDeleted = useRef([]);
  const [showElement, setShowElement] = useState(
    JSON.parse(localStorage.getItem("status"))
  );
  useEffect(() => {
    if (!showElement.includes("USER_B2B")) {
      allSuppliers &&
        allSuppliers.map((element, index2) => {
          uploadAndDownloadService
            .downloadFile(element.fileUrl)
            .then((response) => {
              let index = element.fileUrl.lastIndexOf(".");
              let extension = element.fileUrl.substr(index + 1);

              //Build a URL from the file

              let base64ImageString = Buffer.from(
                response.data,
                "binary"
              ).toString("base64");

              let image = "data:image/png;base64," + base64ImageString;

              myRefs.current[index2].src = image;
            })
            .catch(() => { });
        });
    }

  }, [allSuppliers]);

  useEffect(() => {
    if (!showElement.includes("USER_B2B")) {
      allSuppliersDeleted &&
        allSuppliersDeleted.map((element, index2) => {
          uploadAndDownloadService
            .downloadFile(element.fileUrl)
            .then((response) => {
              // let index = element.fileUrl.lastIndexOf(".");
              // let extension = element.fileUrl.substr(index + 1);

              //Build a URL from the file

              let base64ImageString = Buffer.from(
                response.data,
                "binary"
              ).toString("base64");

              let image = "data:image/png;base64," + base64ImageString;

              myRefsDeleted.current[index2].src = image;
            })
            .catch(() => { });
        });
    }
  }, [allSuppliersDeleted]);

  useEffect(() => {
    allClient &&
      allClient.map((element, index2) => {
        uploadAndDownloadService
          .downloadFile(element.fileUrl)
          .then((response) => {
            // let index = element.fileUrl.lastIndexOf(".");
            // let extension = element.fileUrl.substr(index + 1);

            let base64ImageString = Buffer.from(
              response.data,
              "binary"
            ).toString("base64");

            let image = "data:image/png;base64," + base64ImageString;

            myRefsTwo.current[index2].src = image;
          })
          .catch(() => { });
      });
  }, [allClient]);

  useEffect(() => {
    allClientDeleted &&
      allClientDeleted.map((element, index2) => {
        uploadAndDownloadService
          .downloadFile(element.fileUrl)
          .then((response) => {
            // let index = element.fileUrl.lastIndexOf(".");
            // let extension = element.fileUrl.substr(index + 1);

            let base64ImageString = Buffer.from(
              response.data,
              "binary"
            ).toString("base64");

            let image = "data:image/png;base64," + base64ImageString;

            myRefsTwoDeleted.current[index2].src = image;
          })
          .catch(() => { });
      });
  }, [allClientDeleted]);

  useEffect(() => {
    let partenaires = ["FOURNISSEUR", "CLIENT"];
    let isDeleted = [0, 1];
    startLoading();
    SocieteAndUserService.getListGroupsByIdUser(getCurrentUserId()).then((response) => {
      console.log(response)
      setAllGroupes(response.data.success)
    }).catch((e) => {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : " + e);
    }).finally(() => {
      stopLoading();
    })

    partenaires.forEach((element) => {
      isDeleted.forEach((elementTwo) => {
        SocieteAndUserService.getAllPartenaires(element, elementTwo)
          .then((response) => {
            if (Object.keys(response.data)[0] === "ListSociete") {
              if (element === "FOURNISSEUR" && elementTwo === 0) {
                setAllSuppliers(response.data.ListSociete);
              } else if (element === "CLIENT" && elementTwo === 0) {
                setAllClient(response.data?.ListSociete);
              } else if (element === "FOURNISSEUR" && elementTwo === 1) {
                setAllSuppliersDeleted(response.data.ListSociete);
              } else if (element === "CLIENT" && elementTwo === 1) {
                setAllClientDeleted(response.data?.ListSociete);
              }
            }
          })
          .catch((e) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : " + e);
          });
      });
    });
  }, []);

  const onAddSocieteHandler = () => {
    navigate(`/ajoutertiers`);
  };
  const onAddGroupeHandler = () => {
    navigate(`/ajoutergroupe`);
  };
  const onUploadExcel = () => {
    navigate(`/uploadExcel?type=tiers`);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les tiers</h5>
                  <button
                    class="btn btn-dark float-right"
                    onClick={onAddSocieteHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>

              </div>
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Importer un fichier Excel</h5>
                  <button
                    class="btn btn-dark float-right"
                    onClick={onUploadExcel}
                  >
                    <i class="fas fa-arrow-right"></i>
                  </button>
                </div>

              </div>
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Les groupes</h5>
                  <button
                    class="btn btn-dark float-right"
                    onClick={onAddGroupeHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>

              </div>
              {allGroupes.length > 0 && (
                <ClientGroupeTable
                  listClients={allGroupes}

                />
              )}
              {allSuppliers.length > 0 && (
                <ClientSocieteTable
                  listClients={allSuppliers}
                  typeClient="Fournisseurs "
                  tag="FOURNISSEUR"
                />
              )}
              {allSuppliersDeleted.length > 0 && (
                <ClientSocieteTable
                  listClients={allSuppliersDeleted}
                  typeClient="Fournisseurs Archivés"
                  tag="FOURNISSEUR"

                />
              )}
              {allClient.length > 0 && (
                <ClientSocieteTable
                  listClients={allClient}
                  typeClient="Clients"
                  tag="CLIENT"

                />
              )}
              {allClientDeleted.length > 0 && (
                <ClientSocieteTable
                  listClients={allClientDeleted}
                  typeClient="Clients Archivés"
                  tag="CLIENT"

                />
              )}
            </div>
          </div>
        </div>
      </div>

      {onShowInformationModel && (
        <SocieteInformation
          setOnShowInformationModel={setOnShowInformationModel}
          informationModel={informationModel}
        />
      )}
    </div>
  );
};
export default withLoader(ClientSociete);
